import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currentValue", "enrichedValue", "isEnriched", "fieldType", "numberDisplayHint", "children"];
import { GridList, LayoutBox, Skeleton, useGridList } from 'breeze-intelligence-kit';
import { PropertyValue } from '../EnrichmentPropertiesPanel/PropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichmentAvailableListItem = _ref => {
  let {
      currentValue,
      enrichedValue,
      isEnriched,
      fieldType,
      numberDisplayHint,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isRefreshing
  } = useGridList();
  const displayValue = enrichedValue || currentValue || '';
  return /*#__PURE__*/_jsx(GridList.Item, Object.assign({
    background: isEnriched ? 'background-color-breeze-extra-extra-light' : 'background-color-light'
  }, rest, {
    children: /*#__PURE__*/_jsx(LayoutBox, {
      paddingBlock: "space-xs",
      paddingInline: "space-sm",
      children: children || /*#__PURE__*/_jsx(Skeleton, {
        blockSize: "1.8em",
        isLoading: isRefreshing,
        variant: "breeze",
        children: /*#__PURE__*/_jsx(PropertyValue, {
          fieldType: fieldType,
          numberDisplayHint: numberDisplayHint,
          value: displayValue
        })
      })
    })
  }));
};